import React from 'react'
import { AddLocation, EditLocation, LocationsList } from './Locations';
import { Route, Routes } from 'react-router-dom'


export const OverviewLayout = (() => {
    return (
        <div>
            <Routes>
                <Route path='' element={<LocationsList />} />
                <Route path='/:id/edit' element={<EditLocation />} />
                <Route path='/add' element={<AddLocation />} />
            </Routes>
        </div>
    )
})